import "./Accordion.css";
import TabContent from "../tabs/tabContent/TabContent";
import { TabProps, TabType } from "../tabs/types/tabTypes";

function Accordion({ data }: TabProps) {
  return (
    <div className="accordion" id="accordionItems">
      {data.map((item: TabType, index: number) => {
        return (
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className={`accordion-button ${index > 0 && "collapsed"}`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#${item.id}`}
                aria-expanded="true"
                aria-controls={item.id}
              >
                {item.title}
              </button>
            </h2>
            <div
              id={item.id}
              className={`accordion-collapse collapse ${index === 0 && "show"}`}
              data-bs-parent="#accordionItems"
            >
              <div className="accordion-body">
                <TabContent data={item} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Accordion;
